import React from "react";

export default function EndOfDayLoadSunsetIcon({
  className = "",
  size = 14,
  strokeWidth = 2,
}) {
  return (
    <svg
      aria-hidden="true"
      className={className || undefined}
      fill="none"
      height={size}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      viewBox="0 0 24 24"
      width={size}
    >
      <path d="M4 18h16" />
      <path d="M7 15a5 5 0 0 1 10 0" />
      <path d="M12 5v2" />
      <path d="m5.8 10.8 1.4 1.4" />
      <path d="m18.2 10.8-1.4 1.4" />
    </svg>
  );
}
